import { SxProps } from '@mui/material';
import theme from '../theme';

// Login button id for Fruggr
export const LOGIN_BUTTON_ID = 'app-login';

// Header
export const HEADER_DROPDOWN_MENU_ID = 'header-dropdown-menu';
export const PROFILE_MENU_ID = 'profile-menu';
export const MAIN_MENU_ID = 'main-content';
export const HEADER_HEIGHT = '7rem';
export const HEADER_LINK_STYLE: (props: { isActive: boolean }) => SxProps = ({ isActive = false }) => {
  return {
    justifyContent: 'flex-start',
    p: 0,
    fontFamily: theme.typography.h3.fontFamily,
    fontWeight: 600,
    textAlign: 'left',
    color: isActive ? theme.palette.text.primary : theme.palette.primary.main,
    fontSize: isActive ? '18px' : '1rem',
    backgroundColor: 'transparent',
    '&:focus': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none',
      transition: 'none'
    },
    '&:focus-visible': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none',
      color: theme.palette.text.primary,
      fontSize: '18px',
      transition: 'none'
    },
    '&:hover, &:active': {
      backgroundColor: 'transparent !important',
      boxShadow: 'none',
      color: theme.palette.text.primary,
      transition: 'none'
    }
  };
};

export const HEADER_LI_STYLE: (props: { isActive: boolean }) => SxProps = ({ isActive = false }) => {
  return {
    alignItems: 'stretch',
    display: 'flex',
    backgroundColor: isActive ? theme.palette.primary.light : 'transparent',
    borderRadius: isActive ? '8px' : '0px',
    color: isActive ? theme.palette.text.primary : theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      borderRadius: '8px'
    },
    '&:focus, &:focus-visible': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main
    },
    '&:active': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.palette.primary.main,
      borderRadius: '8px',
      transition: 'background-color 0.2s ease'
    }
  };
};

// Footer
export const FOOTER_HEIGHT = '13.75rem';
